<script lang="ts" setup>
import { _isMobile, isWxMiniProgram } from '@/utils/is'
import { onBeforeUnmount, onMounted } from 'vue'
import { useStorage } from '@/hooks/web/useStorage'
import { getLoginInfo } from '@/utils/CryptoJS'
import { setArms } from '@/utils/tools.js'
import GlobalLoading from '@/components/global-loading/index.vue'
import { useAppStore } from '@/store/modules/app.ts'

const appStore = useAppStore()
const { getStorage } = useStorage()

const onVisibilityChange = () => {
  // volvo 项目去掉息屏亮屏后刷新
  console.info('onVisibilityChange', document.visibilityState)
  /* if(document.visibilityState === 'visible' && _isMobile() && appStore.getCanReload){
      window.location.reload();
  } */
  appStore.setVisibilityStatus(document.visibilityState)
  if (isWxMiniProgram() && document.visibilityState === 'hidden') {
    leaveRoom()
  }
}

const leaveRoom = () => {
  // 若本地有栏目id 缓存则不上报
  console.log('test_beforeunload', getLoginInfo('token'))
  if (!getLoginInfo('name')) return
  if (/personal|column/.test(window.location.href)) {
    return
  }
  let url: any = import.meta.env.VITE_BASE_URL + '/live/leaveRoom'
  navigator.sendBeacon(url + `?roomId=${getStorage('roomId')}&token=${getLoginInfo('token')}`)
  // navigator.sendBeacon(url+`?liveWatchRecordId=${getStorage("liveWatchRecordDatId")}&inviteAccountId=${getStorage("accountId")}&liveRecordId=${getStorage("liveRecordId")}&roomId=${getStorage("roomId")}&token=${getLoginInfo("token")}`);
}

/** 页面横竖屏监听 */
const getScreenOrientation = () => {
  setTimeout(() => {
    // 现代浏览器标准 API
    let result = {}
    if (window.screen?.orientation) {
      const type = window.screen.orientation.type
      result = {
        isPortrait: type.includes('portrait'), // 竖屏
        isLandscape: type.includes('landscape'), // 横屏
        angle: window.screen.orientation.angle // 旋转角度
      }
    }
    // 兼容 iOS 旧版本/ Safari 降级方案 (window.orientation)
    else {
      const angle = window.orientation || 0
      result = {
        isPortrait: angle === 0 || angle === 180, // 竖屏角度：0/180
        isLandscape: angle === 90 || angle === -90, // 横屏角度：90/-90
        angle: angle
      }
    }
    appStore.landscapeStatus = result.isLandscape ? 1 : 0
    console.log('半屏', appStore.landscapeStatus)
  }, 100)
}

onMounted(() => {
  setArms(getLoginInfo('userId'), getLoginInfo('name')) // arms
  document.addEventListener('visibilitychange', onVisibilityChange)
  window.addEventListener('beforeunload', leaveRoom)
  // window.addEventListener("unload", test);
  if (_isMobile()) {
    // 禁止移动端页面滚动
    document.body.style.overflow = 'hidden'
  }
  // 横竖屏监听
  getScreenOrientation()
  window.addEventListener('orientationchange', getScreenOrientation)
})

onBeforeUnmount(() => {
  console.log('--------离开页面')
  document.removeEventListener('visibilitychange', onVisibilityChange)
  document.removeEventListener('orientationchange', getScreenOrientation)
})
</script>

<template>
  <RouterView />
  <GlobalLoading />
</template>

<style lang="less"></style>
